/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';


class Category extends React.Component {

	render() {
		
		return (
            <div>
				{this.props.children}
            </div>
		)
	}
}
;
export default Category;


// WEBPACK FOOTER //
// ./src/routes/category/index.js